import { render, staticRenderFns } from "./ContractorCollectionFiltersArchive.vue?vue&type=template&id=263f7170"
import script from "./ContractorCollectionFiltersArchive.vue?vue&type=script&lang=ts"
export * from "./ContractorCollectionFiltersArchive.vue?vue&type=script&lang=ts"
import style0 from "./ContractorCollectionFiltersArchive.vue?vue&type=style&index=0&id=263f7170&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('263f7170')) {
      api.createRecord('263f7170', component.options)
    } else {
      api.reload('263f7170', component.options)
    }
    module.hot.accept("./ContractorCollectionFiltersArchive.vue?vue&type=template&id=263f7170", function () {
      api.rerender('263f7170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ContractorCollectionFiltersArchive.vue"
export default component.exports